import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase
} from '../inspection-cases';

export class ShutdownComponentsDto extends InspectionCase {
  item_7_1?: InspectionValueCase;
  item_7_2?: InspectionValueCase;
  item_7_3?: InspectionCase;
  item_7_4?: InspectionValueCase;
  item_7_5?: InspectionCase;
  item_7_6?: InspectionCase;
  item_7_7?: InspectionCase;
}

export class ShutdownComponents extends ShutdownComponentsDto {
  constructor(
    data: ShutdownComponentsDto = {
      title: 'המערכת המתוכננת / מותקנת לכיבוי הינה (פרט את רכיבי הכיבוי)'
    }
  ) {
    super(data);
    this.item_7_1 = new InspectionValueCase({
      ...data.item_7_1,
      title: `תוצרת הארוסול`
    });
    this.item_7_2 = new InspectionValueCase({
      ...data.item_7_2,
      title: 'הדגם הארוסול'
    });
    this.item_7_3 = new InspectionCase({
      ...data.item_7_3,
      title: 'דגם הארוסול שתוכנן / הותקן מתאים לנפח החלל המוגן'
    });
    this.item_7_4 = new InspectionValueCase({
      ...data.item_7_4,
      title: 'משקל הארוסול'
    });
    this.item_7_5 = new InspectionCase({
      ...data.item_7_5,
      title:
        'המיקום המתוכנן של הארוסול וצורת התקנתו (זווית התקנה ביחס לאופק) בהתאם להנחיות היצרן'
    });
    this.item_7_6 = new InspectionCase({
      ...data.item_7_6,
      title: 'מידות החלל המוגן מתאים להוראות יצרן הארוסול'
    });
    this.item_7_7 = new InspectionCase({
      ...data.item_7_7,
      title: 'המערכת המתוכננת מתאימה לדרישות היצרן'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.item_7_1.isApplicable || this.item_7_1.isPassed) &&
        (!this.item_7_2.isApplicable || this.item_7_2.isPassed) &&
        (!this.item_7_3.isApplicable || this.item_7_3.isPassed) &&
        (!this.item_7_4.isApplicable || this.item_7_4.isPassed) &&
        (!this.item_7_5.isApplicable || this.item_7_5.isPassed) &&
        (!this.item_7_6.isApplicable || this.item_7_6.isPassed) &&
        (!this.item_7_7.isApplicable || this.item_7_7.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.item_7_1.getNotes(),
      ...this.item_7_2.getNotes(),
      ...this.item_7_3.getNotes(),
      ...this.item_7_4.getNotes(),
      ...this.item_7_5.getNotes(),
      ...this.item_7_6.getNotes(),
      ...this.item_7_7.getNotes()
    ];
  }
}
